import { AxiosInstance } from "axios";
import { IContent } from "./interfaces";

export function getLandingPagesBuilder(apiClient: AxiosInstance) {
  return async function getLandingPages(options?: {
    "slug-prefix"?: string;
    "slug-prefix-exclude"?: string;
    lang?: "tr" | "en";
  }): Promise<IContent.IContentTypeResponse[]> {
    const response = await apiClient.get("/content-type/", {
      params: {
        content_type: "landing-page",
        ...options,
      },
    });
    return response.data;
  };
}

/**
 * https://cms.kunduz.com/api/content-type/?content_type=landing-page&lang=tr&slug-prefix=/another
 */
